export default __webpack_public_path__ + "static/ink-h-8d6d25053f466721ea9e413e380b20fa.jpg";